<template>
  <el-dialog v-model="visible" title="分类编辑" width="1000px" :before-close="handleClose">
    <el-form class="mr20" ref="ruleForm" :model="addRow"  label-width="130px">
      <el-form-item v-if="parentObj" label="上级分类">
        {{parentObj&&parentObj.name}}
      </el-form-item>
      <form-item-rule label="分类名称" prop="name">
        <el-input v-model="addRow.name"></el-input>
      </form-item-rule>
      <form-item-rule label="图标" prop="iconUrl" v-if="addRow.level===2">
        <upload-img v-model="addRow.iconUrl"></upload-img>
      </form-item-rule>
      <form-item-rule label="排序" prop="sort">
        <el-input-number :min="0" :controls="false" v-model="addRow.sort"></el-input-number>
      </form-item-rule>
    </el-form>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="doSave()">确定</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>
import FormItemRule from "/src/components/el/form-item-rule";
import UploadImg from "@/components/upload/UploadImg.vue";

export default {
  name: "add-classify",
  components: {UploadImg, FormItemRule,},
  data() {
    return {
      visible: false,
      addRow: {},
      parentObj:null,
    }
  },
  mixins: [tableBase],
  methods: {
    handleClose() {
      this.visible = false;
    },
    open(row, type,level,parentObj) {
      this.parentObj = parentObj;
      if (row) {
        this.addRow = this.copyObj(row);
      } else {
        this.addRow = {name:"",sort:0,type:type,status:0,parentId:parentObj&&parentObj.id,level:level,iconUrl:""};
      }
      this.visible = true;
    },
    doSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/business/goodsClassify/addOrUpdate", this.addRow, () => {
            this.handleClose();
            this.$emit('load')
            this.message("操作成功");
          })
        }
      })
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>

</style>
